export function createRoutes() {
  return [
    {
      path: 'landingpage',
      component: () => import(/* webpackChunkName: "LandingPageChrome" */ '@/landingpage/LandingPageChrome.vue'),
      children: [
        {
          path: '/',
          name: 'landingPageListChrome',
          component: () => import(/* webpackChunkName: "LandingPageListChrome" */ '@/landingpage/LandingPageListChrome.vue'),
        },
        {
          path: 'create',
          name: 'createLandingPageChrome',
          component: () => import(/* webpackChunkName: "CreateLandingPage" */ '@/landingpage/CreateLandingPage.vue'),
        },
        {
          path: ':id',
          component: () => import(/* webpackChunkName: "EditLandingPageChrome" */ '@/landingpage/EditLandingPageChrome.vue'),
          children: [
            {
              path: '/',
              component: () => import(/* webpackChunkName: "EditLandingPage" */ '@/landingpage/EditLandingPage.vue'),
            },
          ],
        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
